import React,{useState} from 'react';
import ReactDOM from 'react-dom';
import {
  Grid,
  Typography,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  Radio,
  RadioGroup
} from '@mui/material';
import { List } from 'react-virtualized';
import IconButton from '@mui/material/IconButton';
import AlarmIcon from '@mui/icons-material/Alarm';
import HelpIcon from '@mui/icons-material/Help';
import RiskDialog from "./RiskDialog";
import Select,  {
  components
} from 'react-select';
//import { arrayMove, SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import { useSortable } from '@dnd-kit/sortable';

const SortableMultiValue = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.data.value });
  const onMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();
  };
  const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      ...props.style,
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return (
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
          <components.MultiValue {...props} innerProps={innerProps} />
      </div>
  );
};

const SortableMultiValueLabel = (props) => {
  const { listeners, setNodeRef } = useSortable({ id: props.data.value });

  return (
      <div ref={setNodeRef} {...listeners}>
          <components.MultiValueLabel {...props} />
      </div>
  );
};

const INFO_DESCRIPTIONS = {
  // ── descrizioni per label di gruppo ─────────────────────────────────────
  "1. Allineamenti": {
    _group: "Indica quanto il progetto è allineato agli obiettivi strategici",
    "Mondo":"Riferito ad almeno un SDG",
    "Europa": "In connessione con la programmazione europea",
    "Italia": "Se riguarda i cantieri PNRR o attività legate alla manutenzione/prosecuzione di cantieri PNRR",
    "Nessuna delle precedenti": ""   
  },
  "2. Concetti chiave": {
    _group: "Raccoglie i concetti chiave associati al progetto",
    "Fiducia": "Iniziativa legata ad enti in cui riconosce affidabilità e la capacità di realizzare progetti corretti ed efficaci, e quindi attribuisce loro risorse senza imporre vincoli eccessivamente gravosi",
    "Rischio": "Per rischio si intende la possibilità che un progetto/bando non raggiunga gli obiettivi previsti o abbia effetti indesiderati. Se 'Basso', non selezionare. Altrimenti, indicare 'Medio' o 'Alto'",
    "Flessibilità": "Il progetto risponde a opportunità o eventi imprevisti, o contiene aspetti operativi innovativi e flessibili",
    "Nessuna delle precedenti":"",
  },
  "3. Trasversalità metodologica": {
    //_group: "Raccoglie i concetti chiave associati al progetto",
    _group: "",
    "Mobilisation & partnership": "Promuove sinergie con le risorse pubbliche, realizza azioni cofinanziate da partner pubblici, privati e filantropici e svolge attività di intermediazione filantropica (PAAS)",
    "Learning": "Prevede l'acquisizione e l'eleborazione di evidenze scientificamente robuste per valutare l'efficacia e la replicabilità dell'intervento",
    "Advocacy":"Condivide le conoscenze derivanti da valutazioni e stime di impatto e promuove comunicazione e iniziative con enti pubblici per contribuire a nuove policy e cambiamenti sistemici",
    "Internationalization":"Iniziativa volta a rafforzare il posizionamento internazionale della Fondazione, es. con la partecipazione di FCSP a reti internazionali e/o alla realizzazione diretta di iniziative con enti esteri",
    "Nessuna delle precedenti":""
  },
 /* "4. Priorità Tematica prevalente": {
    _group: "Definisce la priorità di esecuzione del progetto nel piano.",
    "Riduzione delle disuguaglianze": "Il progetto è prioritario e deve essere avviato subito.",
    "Sviluppo territoriale sostenibile": "Il progetto può essere avviato nella seconda metà del piano.",
    "Nessuna": "Il progetto è opzionale o rinviabile.",
  },
  "5. Fattori Chiave": {
    _group: "Fattori chiave che condizionano il successo del progetto.",
    "Supporto al sistema del Welfare":"fsffd fdfffdfd fdfdfdfdfdfdfdfd ff", 
    "Sviluppo, rafforzamento e attrazione di competenze":"hngnhgnhnhngh nhnhnffg hhhghfgh hfhghfer g ggfgdfgregdf ", 
    "Opportunità per bambini, giovani, famiglie e persone in condizioni di fragilità":"ggggg hhhnhfdng fghfhtdtrdgd",
    "Attivazione dell'ascensore sociale: educazione, formazione e cultura":"fgfdgfgdfg gdfgdfgfggdfgg gggeewewewes", 
    "Connessione e riequilibrio tra centri e periferie":"aaasds dd dasdsada ed dfsdddsads", 
    "Costruzione di cittadinanza, democrazia e diritti":"dsdsd asd daasdasdsads ddsdasdas dd asdsd as d",
    "Sostenibilità di luoghi e istituzioni nel post PNRR":"gbgdgdrfgdrfrg gfggdg fg fggf rrfrrfd f", 
    "Valorizzazione degli asset dei territori":"gfgdfgfgdf gdfgfg g trettrgfg ggggf", 
    "Attrazione di investimenti e talenti":"gggg mmmjhjggjhj ujhjj", 
    "Innovazione di prodotto, di servizio e di processo nelle organizzazioni":"jhjhj j jhuyyjhjhjh kgjkjjhjj",
    "Transizioni verde ed energetica":"ooiohjioi kkljhkljk klhjhjkk", 
    "Divario tecnologico e digitale":"jjfdghjuuuuu uuuuujuuhh", 
    "Nessuno":"hhhh hhhgh gh "
  },*/
  "6. Velocità d'intervento": {
    _group: "",    
    "Cambiamento sistemico":"Iniziative complesse che mirano a cambiamenti strutturali e duraturi nei sistemi, intervenendo su attori, relazioni e regole, spesso su larga scala e nel medio-lungo periodo",
    "Progetti a impatto":"Iniziative inserite all'interno di un progetto di sviluppo",
    "Progetti di sviluppo":"Iniziative inserite all'interno di un progetto di sviluppo",
    "Tenuta del sistema":"Iniziative che non sono né di cambiamento sistemico, né inserite nei progetti di sviluppo"
  },
  /*
  "7. Tipo/Attributi di progetto": {
    _group: "Velocità di esecuzione prevista per il progetto.",    
    "Emergenza":"ggg gfgfgfdg ggfgdfdf jhjmjjmjmj ",
    "Prevede attività di capacity building/organizational development":"ffgfnn nnnnghnhg hhhgyghy yyyhyyyh ",
    "Altro/Nessuno":"gghghhh hhjjhjj jjkkkmmnmnjj"
  },
   */
  "8. Trasversalità tematica": {
    _group: "Le quattro linee tematiche che la FCSP assume come trasversali e caratterizzanti tutta la propria azione",    
    "Education":"Intervento dove le persone acquisiscono conoscenze, competenze e capacità per sviluppare il proprio potenziale, partecipare alla vita della comunità e costruire in modo consapevole il proprio futuro",
    "Innovation":"Intervento che genera valore sociale, economico e ambientale per persone, comunità e società, diffondendo conoscenza e abilitando l’ecosistema a sviluppare nuovi prodotti, servizi e modelli organizzativi",
    "Participation":"Intervento caratterizzato dal coinvolgimento attivo di persone, enti, organizzazioni in progettazioni, decisioni, azioni e/o creazione di conoscenza volte allo sviluppo sostenibile dei territori",
    "Internationalization":"Intervento caratterizzato dal sostegno a iniziative internazionali, o di internazionalizzazione, o di cooperazione internazionale, realizzate dagli Enti o direttamente dalla Fondazione",
    "Nessuna delle precedenti":""    
  }  
};


// ── Popover leggero, senza librerie aggiuntive ────────────────────────────
function InfoPopover({ text, groupText, children }) {
  const [anchor, setAnchor] = React.useState(null);

  if (!text && !groupText) return children;

  return (
    <span
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={e => setAnchor(e.currentTarget.getBoundingClientRect())}
      onMouseLeave={() => setAnchor(null)}
    >
      {children}
      {anchor && (
        <InfoCard
          text={text}
          groupText={groupText}
          anchor={anchor}
        />
      )}
    </span>
  );
}

// ── Card flottante renderizzata in un portal ──────────────────────────────
function InfoCard({ text, groupText, anchor }) {
  const PAD = 12;
  const style = {
    position:    "fixed",
    top:         anchor.bottom + 6,
    left:        Math.min(anchor.left, window.innerWidth - 320 - PAD),
    zIndex:      9999,
    width:       300,
    background:  "#FFFFFF",
    border:      "1px solid #DDE8E1",
    borderRadius: 10,
    boxShadow:   "0 8px 24px rgba(0,0,0,.12)",
    padding:     "12px 14px",
    fontFamily:  "'Roboto', system-ui, sans-serif",
    fontSize:    13,    
    lineHeight:  1.6,
    color:       "#333",    
    pointerEvents: "none",
  };

  return ReactDOM.createPortal(
    <div style={style}>
      {groupText && (
        <div style={{ fontWeight: 700, color: "#1876D2", marginBottom: 6,
                      fontSize: 12, textTransform: "uppercase",
                      letterSpacing: "0.05em" }}>
          {groupText}
        </div>
      )}
      {text && <div style={{ color: "#445" }}>{text}</div>}
    </div>,
    document.body
  );
}



const MonitoraggioDPP = ({
  scelteDisponibiliDPP,
  scelteDPP,
  handleCheckboxChangeDPP,
  handleRadioChangeDPP,
  handleRischioRadioChange,
  handleImpattoSelectChange,
  disabledFattoriChiave,
  errori
}) => {
  const [openRiskDialog, setOpenRiskDialog] = useState(false);

  const handleOpenRiskDialog = () => {
    setOpenRiskDialog(true);
  };

  const handleCloseRiskDialog = () => {
    setOpenRiskDialog(false);
  };

  const showInfoAboutRisks = () => {
    console.log("POSSO MOSTRARE INFO CALCOLO RISCHIO");
    handleOpenRiskDialog();
  };

  const MenuList = props => {
    const rows = props.children;
    const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
    <div key={key} style={style}>{rows[index]}</div>
    );

    return (
    <List            
        style={{ width: '100%' }}
        width={500}
        height={300}
        rowHeight={30}
        rowCount={rows.length}
        rowRenderer={rowRenderer}
    />
    )
}

  
  const listaImpatto = [      
    { value: 0, label: 'Arcate MOI' },
    { value: 1, label: 'Asset Building For Education' },
    { value: 2, label: 'Attrazione investimenti e piano industriale' },
    { value: 3, label: 'Cavallerizza Reale'},
    { value: 4, label: 'Città dell’Educazione'},
    { value: 5, label: 'Evoluzione Enti Strumentali'},
    { value: 6, label: 'GAM' },
    { value: 7, label: 'Hub Innovazione Genova' },
    { value: 8, label: 'IRCCS Piemonte e Liguria'},
    { value: 9, label: 'Palazzine MOI'},
    { value: 10, label: 'PAAS' },
    { value: 11, label: 'Progetto Giovani' },
    { value: 12, label: 'STEAM'},
    { value: 13, label: 'Strategia AI e supporto AI4I'},
    { value: 14, label: 'Progetto Alberi' },
    { value: 15, label: 'Villa della Regina'},
    { value: 16, label: 'Borgo Medievale'},
  ];

  function getImpattoValue(label) {
    
    const item = listaImpatto.find(el => el.label === label);
    //console.log("GIV",label,item.value,item ? item.value : 0);
    return item ? item.value : 0; 
  }

  
  return (
    <div style={{ display: 'flex', marginTop: '20px', width: '100%' }}>
          <FormControl component="fieldset" style={{ marginLeft: '10px', width: '100%', minWidth: '150px',
                border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '4px', padding: '10px' }}>
                <FormLabel component="legend" style={{ fontSize: '12px', fontWeight: '400',
                          lineHeight: '1.4375em', color:'black', display: 'block',                          
                          fontFamily: 'Roboto, Helvetica, sans-serif', paddingRight:'5px', paddingLeft:'5px'}}>
                        Monitoraggio DPP 2025-2028
                </FormLabel>
                <FormGroup>                                                               
                    <Grid container spacing={2}>
           
                    {/* Pannello Sinistro */}
                         <Grid item xs={12} sm={6}>            
                            {[...Object.keys(scelteDisponibiliDPP)
                                .slice(0, 4)]  // Prime 4 opzioni nel pannello sinistro
                                //.slice(0, 4), Object.keys(scelteDisponibiliDPP).slice(-1)[0]]  // Prime 4 opzioni nel pannello sinistro
                                .map((label) => (
                                <FormControl key={label} component="fieldset" error={!!errori[label]} sx={{ display: "flex", flexDirection: "column",  marginBottom: 2 }}>
                                <Typography variant="subtitle1" style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                                    <InfoPopover 
                                      groupText={INFO_DESCRIPTIONS[label]?._group}
                                    >
                                      <span style={{ cursor: "default" }}>{label}</span>
                                    </InfoPopover>                                                                        
                                </Typography>
                                        {label === "4. Priorità Tematica prevalente" ? (
                                            <RadioGroup
                                            //value={scelteDPP[label] || ""}
                                            value={scelteDPP?.[label] || ""}
                                            onChange={(e) => handleRadioChangeDPP(label, e.target.value)}
                                            >
                                            {scelteDisponibiliDPP[label].map((scelta) => (
                                                <FormControlLabel
                                                key={scelta}
                                                value={scelta}
                                                control={<Radio />}
                                                label={
                                                  <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                                                    <span>{scelta}</span>
                                                  </InfoPopover>
                                                }
                                                />
                                            ))}
                                            </RadioGroup>
                                        ) 
                                :label === "2. Concetti chiave" && Object.entries(scelteDPP?.[label] || {}).some(([key, value]) => key === 'Rischio' && value > 0) ?(                                    
                                    scelteDisponibiliDPP[label].map((scelta) => (                    
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        key={scelta}
                                        control={
                                        <Checkbox                            
                                            //checked={scelte[label]?.[scelta] || false}
                                            //checked={scelteDPP[label]["Rischio"] > 0}
                                            checked={scelteDPP[label]?.[scelta] === true || scelteDPP[label]?.[scelta] > 0}  
                                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                                        />
                                        }                                        
                                        //label={scelta}                                        
                                        label={
                                          scelta === "Rischio" ? (
                                            <InfoPopover text={INFO_DESCRIPTIONS[label]?.["Rischio"]}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                              <span>{scelta}</span>
                                              <IconButton aria-label="alarm" size="small" onClick={showInfoAboutRisks}>
                                                <HelpIcon fontSize="medium" color="primary"/>
                                              </IconButton>
                                            </div>
                                          </InfoPopover>
                                        ) : (
                                          <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                                            <span>{scelta}</span>
                                          </InfoPopover>
                                        )
                                      }                                        
                                    />     
                                    { scelta=="Rischio" ?(                                       
                                    console.log("QUI",scelta),
                                    <RadioGroup
                                    row
                                    //value={rischioLevel[label] || ""}
                                    value={scelteDPP[label]["Rischio"]}
                                    onChange={(e) => handleRischioRadioChange(label, e.target.value)}
                                    >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="Medio"
                                    />
                                    <FormControlLabel
                                        value={2}
                                        control={<Radio />}
                                        label="Alto"
                                    />
                                    </RadioGroup>     
                                    
                                    ):(console.log("QUA",scelta),
                                    <></>)}         
                                    </div>
                                ))
                                )
                                : (
                                    // Scelta multipla con checkbox
                                    scelteDisponibiliDPP[label].map((scelta) => (
                                    <FormControlLabel
                                        key={scelta}
                                        control={
                                        <Checkbox
                                            checked={scelteDPP[label]?.[scelta] || false}
                                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                                        />
                                        }
                                        //label={scelta}
                                        label={
                                          scelta === "Rischio" ? (
                                            <InfoPopover text={INFO_DESCRIPTIONS[label]?.["Rischio"]}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                              <span>{scelta}</span>
                                              <IconButton aria-label="alarm" size="small" onClick={showInfoAboutRisks}>
                                                <HelpIcon fontSize="medium" color="primary"/>
                                              </IconButton>
                                            </div>
                                          </InfoPopover>
                                        ) : (
                                          <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                                            <span>{scelta}</span>
                                          </InfoPopover>
                                        )
                                      }  
                                    />
                                    ))
                                )}
                                {/* Messaggio di errore se non compilato */}
                                {errori[label] && <FormHelperText>{errori[label]}</FormHelperText>}
                                </FormControl>
                            ))}
                         </Grid>

                    {/* Pannello Destro */}
                        <Grid item xs={12} sm={6}>
            
            {Object.keys(scelteDisponibiliDPP)
              //.slice(4,7) // Ultime 2 opzioni nel pannello destro
              .slice(4,8) // Ultime 2 opzioni nel pannello destro
              .map((label) => (
                <FormControl key={label} component="fieldset" error={!!errori[label]} sx={{  display: "flex", flexDirection: "column", marginBottom: 2 }}>
                   <Typography variant="subtitle1" style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                                    <InfoPopover
                                      groupText={INFO_DESCRIPTIONS[label]?._group}
                                    >
                                      <span style={{ cursor: "default" }}>{label}</span>
                                    </InfoPopover>                                                                        
                                </Typography>            
                   {label === "6. Velocità d'intervento" ? (
                    
                    <RadioGroup
                      value={scelteDPP?.[label] || ""}
                      onChange={(e) => handleRadioChangeDPP(label, e.target.value)}
                    >
                      {scelteDisponibiliDPP[label].map((scelta) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          key={scelta}
                          value={scelta}
                          control={<Radio />}
                          label={
                            <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                              <span>{scelta}</span>
                            </InfoPopover>
                          }
                        />
                        { (scelta=="Progetti a impatto"  && scelteDPP?.["6. Velocità d'intervento"]=="Progetti a impatto") || 
                        scelta=="Progetti di sviluppo"  && scelteDPP?.["6. Velocità d'intervento"]=="Progetti di sviluppo"?(   

                        console.log("QUIMP",scelta,scelteDPP["6. Velocità d'intervento"],scelteDPP?.["100. Progetti a impatto"],listaImpatto[getImpattoValue(scelteDPP?.["100. Progetti a impatto"])]),
                        <div style={{ width: "70%"}}>
                            <Select
                              className="basic-single"
                              placeholder="Seleziona"
                              onChange={(e) => handleImpattoSelectChange(label, e)}
                              options={listaImpatto}
                              defaultValue={listaImpatto[getImpattoValue(scelteDPP?.["100. Progetti a impatto"])]}
                              />
                        </div>
                        ):(//console.log("QUA",scelta),
                        <></>)} 
                        </div>
                      ))}
                    </RadioGroup>
                   
                        
                    ) 
                   
                   //////
                   /*
                   :label === "6. Velocità d'intervento" && Object.entries(scelteDPP?.[label] || {}).some(([key, value]) => key === 'Progetti a impatto' && value > 0) ?(
                    scelteDisponibiliDPP[label].map((scelta) => (                    
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        key={scelta}
                        control={
                        <Checkbox                                                        
                            checked={scelteDPP[label]?.[scelta] === true || scelteDPP[label]?.[scelta] >0}  
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                        />
                        }                                                                                   
                        label={
                          scelta === "Progetti a impatto" ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <span>{scelta}</span>                              
                            </div>
                          ) : (
                            scelta
                          )
                        }

                    />     
                    { scelta=="Progetti a impatto" ?(
                    console.log("QUIMP",scelta),
                    <div style={{ width: "100%"}}>
                        <Select
                          className="basic-single"
                          placeholder="Seleziona"
                          onChange={(e) => handleImpattoSelectChange(label, e)}
                          options={listaImpatto}
                          />
                    </div>
                    ):(console.log("QUA",scelta),
                    <></>)}         
                    </div>
                ))
                )  
                //////
                */   
                   
                   : label === "5. Fattori Chiave" ? (
                    console.log("WEBZ".label,scelteDisponibiliDPP[label]),
                    /*scelteDisponibiliDPP[label].map((scelta) => (
                      <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            disabled={disabledFattoriChiave}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={scelta}
                      />
                    ))*/
                    scelteDisponibiliDPP[label].map((scelta) => (
                      scelta == "Nessuno" ? (
                        <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            //disabled={!disabledFattoriChiave}
                            disabled={true}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={
                          <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                            <span>{scelta}</span>
                          </InfoPopover>
                        }
                      />):(
                        <FormControlLabel
                        key={scelta}                        
                        control={
                          <Checkbox
                            disabled={disabledFattoriChiave}
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={
                          <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                            <span>{scelta}</span>
                          </InfoPopover>
                        }
                      />
                      )                                            
                    ))
                   )
                   
                   : (
                    // Scelta multipla con checkbox
                    scelteDisponibiliDPP[label].map((scelta) => (
                      <FormControlLabel
                        key={scelta}
                        
                        control={
                          <Checkbox
                            
                            checked={scelteDPP[label]?.[scelta] || false}
                            onChange={() => handleCheckboxChangeDPP(label, scelta)}
                          />
                        }
                        label={
                          <InfoPopover text={INFO_DESCRIPTIONS[label]?.[scelta]}>
                            <span>{scelta}</span>
                          </InfoPopover>
                        }
                      />
                    ))
                  )}

                  {/* Messaggio di errore se non compilato */}
                  {errori[label] && <FormHelperText>{errori[label]}</FormHelperText>}
                </FormControl>
              ))}
                        </Grid>
                    </Grid>
                </FormGroup>
          </FormControl>
         
          <RiskDialog
            open={openRiskDialog}
            onClose={handleCloseRiskDialog}
          />
    </div>
  );
};

export default MonitoraggioDPP;
